import { cn } from "@omni/utils/styles";

import { useProductPageContext } from "@/components/ProductPage/context/productPage.context";
import { ConditionalWrapper } from "@/utils/helpers";

type Props = {
    className?: string;
};

export const Usps = ({ className }: Props) => {
    const { usps } = useProductPageContext();

    if (!usps?.length) return null;

    return (
        <section
            className={cn(
                "tw:bg-grey-500 tw:border-grey-600 tw:border tw:rounded-sm tw:p-4 tw:mb-6",
                className
            )}
        >
            <ul className={cn("tw:mb-0")}>
                {usps.map(({ text, icon, link }, index) => (
                    <li key={index}>
                        <ConditionalWrapper
                            condition={!!link}
                            wrapper={(children) => {
                                return (
                                    <a
                                        className={cn("tw:no-underline")}
                                        href={link}
                                    >
                                        {children}
                                    </a>
                                );
                            }}
                        >
                            <div
                                className={cn(
                                    "tw:flex tw:items-center tw:gap-2 tw:text-black"
                                )}
                            >
                                {icon && (
                                    <i
                                        className={cn(
                                            "las la-lg",
                                            `la-${icon}`
                                        )}
                                    />
                                )}
                                <p
                                    className={cn("tw:m-0 tw:font-bold", {
                                        "tw:hover:underline": !!link
                                    })}
                                >
                                    {text}
                                </p>
                            </div>
                        </ConditionalWrapper>
                    </li>
                ))}
            </ul>
        </section>
    );
};
